module.exports = __webpack_public_path__ + "static/media/bg12.71f816ca.jpg";